// import {NativeModules} from 'react-native';
import {Platform} from 'react-native';
import Reactotron, {asyncStorage, networking} from 'reactotron-react-native';
import {reactotronRedux} from 'reactotron-redux';

import {AsyncStorage} from '/util/async-storage';
// let scriptHostname;
// if (__DEV__) {
//   const scriptURL = NativeModules.SourceCode.scriptURL;
//   scriptHostname = scriptURL.split('://')[1].split(':')[0];
// }
let reactotron;
if (__DEV__ && Platform.OS !== 'web') {
  reactotron = Reactotron.setAsyncStorageHandler(AsyncStorage)
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    .configure()
    .useReactNative({
      storybook: true,
    })
    .use(reactotronRedux())
    // @ts-expect-error TS(2345): Argument of type '(reactotron: ReactotronCore) => ... Remove this comment to see the full error message
    .use(networking())
    // @ts-expect-error TS(2345): Argument of type '(reactotron: ReactotronCore) => ... Remove this comment to see the full error message
    .use(asyncStorage())
    .connect();
  // @ts-expect-error TS(2339): Property 'tron' does not exist on type 'Console'.
  // eslint-disable-next-line no-console
  console.tron = Reactotron.log;
}
export {reactotron as Reactotron};
